import React, { useRef, useEffect } from "react";

import './letters.css';

const ChladniPlate = () => {
  const canvasRef = useRef(null);
  const animationRef = useRef(null);

  let time = 0;

  let current = {
    m: randMode(),
    n: randMode(),
  };

  let next = {
    m: randMode(),
    n: randMode(),
  };

  let transition = 0;
  const transitionSpeed = 0.004;

  function randMode() {
    return Math.floor(Math.random() * 9) + 2;
  }

  // Smoothstep easing
  const smooth = (t) => t * t * (3 - 2 * t);

  // Simple heatmap (blue → cyan → yellow → red)
  const heatColor = (v) => {
    const x = Math.min(1, Math.max(0, v));
    const r = Math.floor(255 * Math.min(1, Math.max(0, 2 * x - 0.5)));
    const g = Math.floor(255 * Math.min(1, Math.max(0, 2 * x)));
    const b = Math.floor(255 * (1 - x));
    return [r, g, b];
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const w = canvas.width;
    const h = canvas.height;

    const draw = () => {
      const image = ctx.createImageData(w, h);
      const data = image.data;

      time += 0.02;
      transition += transitionSpeed;

      if (transition >= 1) {
        transition = 0;
        current = next;
        next = { m: randMode(), n: randMode() };
      }

      const t = smooth(transition);
      const m = current.m * (1 - t) + next.m * t;
      const n = current.n * (1 - t) + next.n * t;

      for (let y = 0; y < h; y++) {
        for (let x = 0; x < w; x++) {
          const nx = x / w;
          const ny = y / h;

          const z =
            Math.sin(Math.PI * m * nx + time) *
              Math.sin(Math.PI * n * ny + time) +
            Math.sin(Math.PI * n * nx - time) *
              Math.sin(Math.PI * m * ny - time);

          // Normalize amplitude to [0,1]
          const amplitude = Math.min(1, Math.abs(z));

          const [r, g, b] = heatColor(amplitude);

          const i = (y * w + x) * 4;
          data[i] = r;
          data[i + 1] = g;
          data[i + 2] = b;
          data[i + 3] = 255;
        }
      }

      ctx.putImageData(image, 0, 0);
      animationRef.current = requestAnimationFrame(draw);
    };

    draw();

    return () => cancelAnimationFrame(animationRef.current);
  }, []);

  return (
    <div className="letter-grid">
      <canvas
        ref={canvasRef}
        style={{
          display: "block",
          width: "100vw",
          height: "100vh",
          margin: "0 auto",
          background: "#000",
        }}
      />
    </div>
  );
};

export default ChladniPlate;
